export default __webpack_public_path__ + "static/media/payment-check-tablet.89421214.svg";